module.exports = __webpack_public_path__ + "img/electromagnetism.e3560c4c.jpg";